import styled from '@emotion/styled';
import { Box, IconButton } from '@mui/material';
import { GridExpandMoreIcon, GridRenderCellParams } from '@mui/x-data-grid-pro';

export const RowExpandContainer = styled(Box)(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            width: '20px',
            height: '20px'
        }
    }
});

export const StyledGridExpandMoreIcon = styled(GridExpandMoreIcon, {
    shouldForwardProp: (prop) => prop !== 'isExpanded'
})<any>(({ theme, isExpanded }) => {
    return {
        transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
        transition: '150ms'
    }
});

function CustomDetailPanelToggle(props: Pick<GridRenderCellParams, 'id' | 'value'>) {
    const { value: isExpanded } = props;

    return (
        <IconButton
            size="large"
            tabIndex={-1}
            aria-label={isExpanded ? 'Close' : 'Open'}
        >
            <StyledGridExpandMoreIcon isExpanded={isExpanded} />
        </IconButton>
    );
}

const APRowExpand = (props: GridRenderCellParams<any>) => {
    const { value, id } = props;

    return (
        <RowExpandContainer data-testid="ap-row-expand">
            <CustomDetailPanelToggle id={id} value={value} />
        </RowExpandContainer>);
}

export default APRowExpand;
